module.exports = __webpack_public_path__ + "img/开盒记录按钮_新春年货节活动.115ab0c3.png";